module.exports = __webpack_public_path__ + "static/media/how-to-grow-food-in-a-concrete-jungle.c8871689.jpg";